import { RestService } from '@abp/ng.core';
import type { ListResultDto, PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { BaseCourseDto, TenantCourseWithApprovalDataDto } from '../courses/models';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class TenantCourseLookupService {
  apiName = 'Default';
  

  getTenantCourseLookup = () =>
    this.restService.request<any, ListResultDto<BaseCourseDto>>({
      method: 'GET',
      url: '/api/app/tenant-course-lookup/tenant-course-lookup',
    },
    { apiName: this.apiName });
  

  getTenantCourseWithApprovalDataLookup = () =>
    this.restService.request<any, ListResultDto<TenantCourseWithApprovalDataDto>>({
      method: 'GET',
      url: '/api/app/tenant-course-lookup/tenant-course-with-approval-data-lookup',
    },
    { apiName: this.apiName });
  

  getTenantCoursesLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/tenant-course-lookup/tenant-courses-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  getTenantCoursesWithApprovalDataLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/app/tenant-course-lookup/tenant-courses-with-approval-data-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
